var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFirecrackersAlt1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 1C5.98858 1 3.75 3.26555 3.75 6.06026V7.32532C3.75 7.74453 4.08579 8.08436 4.5 8.08436C4.91421 8.08436 5.25 7.74453 5.25 7.32532V6.06026C5.25 4.10397 6.817 2.51808 8.75 2.51808C10.683 2.51808 12.25 4.10397 12.25 6.06026V6.62707H10.108C9.01835 6.62707 8.13501 7.54476 8.13501 8.67679V8.93301H18V8.67679C18 7.54476 17.1167 6.62707 16.027 6.62707H13.75V6.06026C13.75 3.26555 11.5114 1 8.75 1Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.24954 10.2452C4.53848 9.945 4.53848 9.45832 4.24954 9.15815C3.96061 8.85797 3.49214 8.85797 3.2032 9.15815L2.2167 10.183C1.92777 10.4832 1.92777 10.9699 2.2167 11.27C2.50564 11.5702 2.97411 11.5702 3.26304 11.27L4.24954 10.2452Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.17621 10.2452C4.88727 9.945 4.88727 9.45832 5.17621 9.15815C5.46515 8.85797 5.93361 8.85797 6.22255 9.15815L7.20905 10.183C7.49799 10.4832 7.49799 10.9699 7.20905 11.27C6.92011 11.5702 6.45165 11.5702 6.16271 11.27L5.17621 10.2452Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.71286 10.9827C5.12149 10.9827 5.45274 11.3269 5.45274 11.7514V12.7762C5.45274 13.2008 5.12149 13.5449 4.71286 13.5449C4.30424 13.5449 3.97299 13.2008 3.97299 12.7762V11.7514C3.97299 11.3269 4.30424 10.9827 4.71286 10.9827Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18 10.4703H8.13501V18.1568H18V10.4703Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.13501 19.9503V19.6941H18V19.9503C18 21.0823 17.1167 22 16.027 22H10.108C9.01835 22 8.13501 21.0823 8.13501 19.9503Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirecrackersAlt1);
export default __webpack_public_path__ + "static/media/firecrackers-alt-1.3249fdbe8f0db2f77a20c5dbf888e731.svg";
export { ForwardRef as ReactComponent };